<script setup>
  import { computed } from 'vue'
  import { useStormStore } from "@/stores/StormStore";

  import { useSheetController } from '@/composables/useSheetsController';

  import MapButtonSidebar from "@/components/MapButtonSidebar.vue";
  import Icon from "@/components/icons/Icon.vue";

  const stormStore = useStormStore();

  await stormStore.getStormsData();

  const stormName = computed(() => stormStore.activeStorms.length > 0 ? stormStore.selectedStorm.status.stormfullname : 'No Active Storms');
  const activeStorms = computed(() => stormStore.activeStorms.length > 0);

  function handleCick() {
    useSheetController.toggleSheet('config', 'storm-selection');
  }  

</script>

<template>
  <div
    class="jwx-map__storm-header jwx-map-block jwx-map-block--transparent-border"
    data-map="jwx-map-name"
  >
    <div class="jwx-v-map-storm-block jwx-map-block__content">
      <button
        @click.prevent="handleCick"
        class="jwx-map-name jwx-v-map-storm-block__button jwx-map-button jwx-map-button--text"
      >
        <span class="jwx-v-map-storm-block__name">{{ stormName }}</span>
        <span v-if="activeStorms" class="jwx-v-map-storm-block__advisory-time">{{ stormStore.selectedStorm.advisory.localtimestring }}</span>       
      </button>
      <MapButtonSidebar
        class="jwx-v-map-storm-block__advisory-button jwx-map-button--primary" 
        type="storm" 
        content="storm-advisory"
        accessibleLabel="Storm Advisory"
      >
        <Icon name="wind-warning" class="jwx-map-button__icon" />  
      </MapButtonSidebar>
    </div>
  </div>  
</template>

<style lang="scss">
  .jwx-v-map-storm-block {
    width: 100%;
  }

.jwx-v-map-storm-block__button {
  display: flex;
  flex-direction: column;
  padding: .325rem var(--jwx-block-spacing-md) .325rem var(--jwx-block-spacing) ;
  align-items: flex-start;
}

.jwx-v-map-storm-block__name {
  font-weight: 600;
}

.jwx-v-map-storm-block__advisory-time {
  font-size: .875rem;
}  

.jwx-v-map-storm-block__advisory-button {
  position: relative;
  z-index: 1;
}

.jwx-v-map-storm-block__advisory-button.selected::before,
.jwx-v-map-storm-block__advisory-button:hover::before {
  opacity: 0;
}

.jwx-v-map-storm-block__advisory-button::before {
  content: "";
  position: absolute;
  top: 50%;
  left: 0;
  width: 1px;
  height: 1.5rem;
  background-color: var(--jwx-button-border-color);
  transform: translateY(-50%);
  opacity: 1;
  z-index: 0;
  transition: opacity 200ms ease-in-out;
}  
</style>